module.exports = __webpack_public_path__ + "static/media/IMG_1882.6c38a3f0.JPG";